<template>
  <div class="registration-page">
    <app-container>
      <h1 class="registration-page__title">Профориентационный <br> тест</h1>
      <div class="page-grid">
        <registration-form />
        <img
          class="page-grid__image"
          src="@/assets/images/registration-bg.svg"
        >
      </div>
    </app-container>
  </div>
</template>

<script>
import RegistrationForm from '../components/Forms/RegistrationForm';
import AppContainer from '../components/Base/AppContainer';

export default {
  name: 'Registration',
  components: {
    RegistrationForm, AppContainer,
  },
};
</script>

<style lang="scss" scoped>
  .registration-page {
    padding: 40px 0;
  }
  @media screen and (max-width: 1200px) {
    .registration-page {
      &__title {
        font-size: 40px;
      }
    }
  }
  @media screen and (max-width: 992px) {
    .registration-page {
      &__title {
        font-size: 40px;
      }
    }
  }
  @media screen and (max-width: 576px) {
    .registration-page{
      &__title {
        font-size: 22px;
      }
    }
  }
</style>
